import { isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";

import { DEFAULT_COLUMNS_KEY, SELECT_ALL_KEY } from "globals/constants";
import { encodeSearchTerms } from "utils/helpers";
import { api } from "services";

export const getTotalProjects = async ({ searchTerms } = { searchTerms: [] }) => {
	const response = await findProjects({
		pageLimit: 1,
		pageOffset: 0,
		searchTerms,
		fieldKeys: [ "id" ],
	});

	return response.totalItems;
};

export const findProjects = async ({ pageLimit: incomingPageLimit, pageOffset, searchTerms }) => {
	if (incomingPageLimit === undefined) {
		throw Error("page limit cannot be null");
	} else if (pageOffset === undefined) {
		throw Error("page offset cannot be null");
	}

	const pageLimit = incomingPageLimit === SELECT_ALL_KEY
		? await getTotalProjects({ searchTerms })
		: incomingPageLimit;

	if (pageLimit === 0) {
		return Promise.resolve({ items: [], totalItems: 0 });
	}

	const response = await api.project.getList({
		page: parseInt(pageOffset, 10),
		size: parseInt(pageLimit, 10),
		sort: "createdOn%3Adesc",
		search: encodeSearchTerms(searchTerms),
	});

	return {
		items: (response?.content || []).map(project => ({
			id: project.projectId,
			title: project.title,
			projectNumber: project.projectNumber,
			status: project.status
		})),
		totalItems: response?.totalElements,
	};
};

const gatProjectSummaryValue = (string, defaultValue = "--") => {
	if (!string) {
		return defaultValue;
	}

	const list = string.split(",");

	if (list.length >= 2) {
		return list.reduce((acc, item) => {
			const value = item !== "null" ? item : "";

			return acc.length > 1 ?  `${acc}, ${value}` : value;
		}, "");
	}

	return string !== "null" && isNonEmptyString(string) ? string : defaultValue;
};

export const mapProjectSummary = (data) => {
	return Object.values(DEFAULT_COLUMNS_KEY).reduce((acc, key) => {
		acc[key] = gatProjectSummaryValue(data?.[key]);

		return acc;
	}, {});
};
